// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface UpgradeDetail {
    message: string;
    reset_at?: string;
    limit?: number;
    used?: number;
}

/**
 * Global modal hiển thị khi free user đạt giới hạn tạo nội dung hàng ngày.
 * Lắng nghe CustomEvent 'eduapp-upgrade-required' từ apiFetch.
 */
export default function UpgradeModal() {
    const [detail, setDetail] = useState<UpgradeDetail | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const handler = (e: CustomEvent<UpgradeDetail>) => {
            setDetail(e.detail);
        };
        window.addEventListener('eduapp-upgrade-required', handler as EventListener);
        return () => window.removeEventListener('eduapp-upgrade-required', handler as EventListener);
    }, []);

    if (!detail) return null;

    const resetTime = detail.reset_at
        ? new Date(detail.reset_at).toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' })
        : null;

    return (
        <div
            className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
            style={{ background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}
            onClick={() => setDetail(null)}
        >
            <div
                className="relative w-full max-w-md rounded-2xl shadow-2xl overflow-hidden"
                style={{ background: 'var(--color-surface, #1e1e2e)' }}
                onClick={e => e.stopPropagation()}
            >
                {/* Header gradient */}
                <div className="h-2 w-full" style={{ background: 'linear-gradient(90deg, #6366f1, #8b5cf6, #ec4899)' }} />

                <div className="p-6 space-y-4">
                    {/* Icon + Title */}
                    <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-xl flex items-center justify-center text-2xl"
                            style={{ background: 'rgba(99,102,241,0.15)' }}>
                            ⚡
                        </div>
                        <div>
                            <h2 className="font-bold text-lg" style={{ color: 'var(--color-text-primary, #fff)' }}>
                                Đã đạt giới hạn hôm nay
                            </h2>
                            <p className="text-sm" style={{ color: 'var(--color-text-secondary, #999)' }}>
                                {detail.used}/{detail.limit} lượt tạo nội dung
                            </p>
                        </div>
                    </div>

                    {/* Message */}
                    <p className="text-sm leading-relaxed" style={{ color: 'var(--color-text-secondary, #aaa)' }}>
                        {detail.message}
                    </p>

                    {resetTime && (
                        <p className="text-xs" style={{ color: 'var(--color-text-muted, #666)' }}>
                            🔄 Lượt dùng reset lúc {resetTime} hôm nay
                        </p>
                    )}

                    {/* Premium benefits */}
                    <div className="rounded-xl p-4 space-y-2" style={{ background: 'rgba(99,102,241,0.08)', border: '1px solid rgba(99,102,241,0.2)' }}>
                        <p className="text-xs font-semibold mb-2" style={{ color: '#a5b4fc' }}>Premium bao gồm:</p>
                        {[
                            '✅ Tạo nội dung không giới hạn mỗi ngày',
                            '✅ AI chất lượng cao (Gemini 2.5 Flash)',
                            '✅ Tạo video bài giảng AI',
                            '✅ Mô hình 3D tương tác',
                            '✅ Lưu trữ không giới hạn',
                        ].map(item => (
                            <p key={item} className="text-xs" style={{ color: 'var(--color-text-secondary, #aaa)' }}>{item}</p>
                        ))}
                    </div>

                    {/* Actions */}
                    <div className="flex gap-3 pt-1">
                        <button
                            onClick={() => setDetail(null)}
                            className="flex-1 py-2.5 rounded-xl text-sm font-medium transition-opacity hover:opacity-70"
                            style={{ background: 'rgba(255,255,255,0.08)', color: 'var(--color-text-secondary, #aaa)' }}
                        >
                            Để sau
                        </button>
                        <button
                            onClick={() => { setDetail(null); navigate('/nang-cap'); }}
                            className="flex-1 py-2.5 rounded-xl text-sm font-bold transition-transform hover:scale-[1.02]"
                            style={{ background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: '#fff' }}
                        >
                            Nâng cấp Premium
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
